define('core/views/media/DragDropUploadView',[
    'underscore',
    'backbone',

    'core/utils',
], function (
    _,
    Backbone,

    utils
) {
    'use strict';

    var handler = utils.stopEventHandler;

    // Drag and drop view
    // Expects to be assigned an element, which it will watch
    // for image files being dropped on
    // TODO: Refactor, this should not be a view
    var DragDropUploadView = Backbone.View.extend({
        events: {
            'dragover': '_dragOn',
            'dragenter': '_dragOn',
            'dragleave': '_dragOff',
            'dragexit': '_dragOff',
            'drop': '_drop',
        },

        _dragOn: handler(function () {
            this.trigger('uploader:dragEnter');
            this._toggleDragPlaceholder(true);
        }),

        _dragOff: handler(function () {
            this._toggleDragPlaceholder(false);
        }),

        _drop: handler(function (evt) {
            this._toggleDragPlaceholder(false);

            var files = evt.originalEvent.dataTransfer.files;
            if (!files.length)
                return void this.trigger('uploader:dropError', 'No files');

            this.trigger('uploader:attachMedia', files);
        }),

        _toggleDragPlaceholder: _.throttle(function (show) {
            if (show)
                this.trigger('uploader:showPlaceholder');
            else
                this.trigger('uploader:hidePlaceholder');
        }, 50),
    });

    return DragDropUploadView;
});

